<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.CaseSummaryEmailFax">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-case-summary-digital-caseflow-modal [flowLog]="data.log" (closed)="close()" (refreshed)="onRefreshed()"></app-case-summary-digital-caseflow-modal>
      </mat-dialog-content>
</div>
